export const NOTIFICATION_TYPE = {
  become_moderator: `become_moderator`,
  become_leader: `become_leader`,
  post_waiting_approval: `post_waiting_approval`,
  report_waiting_moderation: `report_waiting_moderation`,
  changed_community_name: `changed_community_name`,
};
